export const CONTRACT_STATUS_COLORS = {
  "VAŽI": "#9e9e9e",
  "USKORO ISTIČE": "#fb8c00",
  "ISTEKAO": "#e53935",
  "BEZ ROKA": "#9e9e9e",
};

export function contractStatusColor(status) {
  return CONTRACT_STATUS_COLORS[status] || "#9e9e9e";
}

export function isHealthyContractStatus(status) {
  return status === "VAŽI" || status === "BEZ ROKA";
}

export function contractStatusLabel(contract, t) {
  if (contract.status === "USKORO ISTIČE" && contract.dana_do_isteka != null) {
    return t("contract_expires_in_days", { count: contract.dana_do_isteka });
  }
  if (contract.status === "ISTEKAO" && contract.dana_do_isteka != null) {
    return t("contract_expired_days_ago", { count: Math.abs(contract.dana_do_isteka) });
  }
  if (contract.status === "BEZ ROKA") return t("contract_status_no_deadline");
  return t("contract_status_active");
}
